export default __webpack_public_path__ + "static/tunaSteaks-f787abf4566a86e6d00b9cfe9538a416.jpeg";